import React from 'react';
import styled from 'astroturf/react';
import _Wrapper from "AttachmentThumbnail-Wrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/login_modal/components/AttachmentThumbnail.tsx?styleId=Wrapper";
import _Container from "AttachmentThumbnail-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/login_modal/components/AttachmentThumbnail.tsx?styleId=Container";
import _Thumbnail from "AttachmentThumbnail-Thumbnail.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/login_modal/components/AttachmentThumbnail.tsx?styleId=Thumbnail";
import _Ribbon from "AttachmentThumbnail-Ribbon.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/login_modal/components/AttachmentThumbnail.tsx?styleId=Ribbon";
import _RibbonTriangle from "AttachmentThumbnail-RibbonTriangle.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/login_modal/components/AttachmentThumbnail.tsx?styleId=RibbonTriangle";


type Props = {
  attachmentThumbnailUrl: string;
};

const Wrapper = /*#__PURE__*/styled("div", null, {
  displayName: "Wrapper",
  styles: _Wrapper
});

const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const Thumbnail = /*#__PURE__*/styled("img", null, {
  displayName: "Thumbnail",
  styles: _Thumbnail
});

const Ribbon = /*#__PURE__*/styled("div", null, {
  displayName: "Ribbon",
  styles: _Ribbon
});

const RibbonTriangle = /*#__PURE__*/styled("div", null, {
  displayName: "RibbonTriangle",
  styles: _RibbonTriangle
});

export const AttachmentThumbnail: React.FC<Props> = ({
  attachmentThumbnailUrl,
}) => {
  return (
    <Wrapper>
      <Container>
        <Thumbnail src={attachmentThumbnailUrl} alt="PDF Thumbnail" />
        <Ribbon>Download Free PDF</Ribbon>
        <RibbonTriangle />
      </Container>
    </Wrapper>
  );
};
